import { HttpClient as CapHttpClient } from '@spryrocks/capacitor-http-plugin';
import { Injectable } from '@angular/core';
import { SendRequestOptions, RequestOptions } from '../../adyen-types';
import { LocalStorage } from '@pos-common/services/utils/localstorage.utils';
import { StorageKeys } from '@pos-common/constants/storage.const';
import { LogService } from '@pos-common/services/system/logger';
import { RequestHeaderTypes } from '@pos-common/constants';
import { PAYMASH_PROFILE } from '@profile';

@Injectable()
export class AdyenApiHelper {
  private readonly logger = this.logService.createLogger('AdyenApiHelper');
  constructor(private readonly localStorage: LocalStorage, private readonly logService: LogService) {}

  get<TResponse>(endpoint: string, options?: RequestOptions) {
    return this.sendRequest<TResponse>({
      endpoint,
      method: 'get',
      errorHandler: options?.errorHandler,
      readTimeout: options?.readTimeout,
    });
  }

  post<TResponse>(endpoint: string, data: unknown, options?: RequestOptions) {
    return this.sendRequest<TResponse>({
      endpoint,
      method: 'post',
      data,
      errorHandler: options?.errorHandler,
      readTimeout: options?.readTimeout,
    });
  }

  private async sendRequest<TResponse>(options: SendRequestOptions): Promise<TResponse> {
    const { endpoint, method, data, errorHandler, readTimeout } = options;
    this.logger.info('Send request', { endpoint, method, data });
    const apiKey = this.getApiKey();
    const headers = this.createHeaders(apiKey);
    const response = await CapHttpClient.sendRequest({
      url: this.getNewEndpoint(endpoint),
      method,
      data,
      headers,
      responseType: 'json',
      readTimeout: readTimeout || PAYMASH_PROFILE.requestTimeout.sendRequest,
    }).catch((error) => {
      if (errorHandler) throw errorHandler(error);
      throw error;
    });
    this.logger.info('Response data', { endpoint, method, data: response.data });
    return response.data;
  }

  private createHeaders(apiKey: string) {
    const headers = { [RequestHeaderTypes.ContentType]: 'application/json' };
    if (apiKey) {
      headers[RequestHeaderTypes.ApiKey] = apiKey;
    }
    return headers;
  }

  private getApiKey(): string {
    const apiKey = this.localStorage.get(StorageKeys.paymashPayKey);
    if (!apiKey) throw new Error('Please provide Adyen api key in the settings');
    return apiKey;
  }

  private getNewEndpoint(endpoint: string) {
    const testMercahntIdRegex = /^Paymash_\w+_TEST/g;
    const merchantId = this.localStorage.get(StorageKeys.paymashPayMerchantId);
    if (testMercahntIdRegex.test(merchantId)) {
      return endpoint.replace('-live.adyen.com', '-test.adyen.com');
    }
    return endpoint;
  }
}
